function extractTextFromChildNodes(node: Node, extractTextFn: (node: Node) => string): string {
  return Array.from(node.childNodes).map(extractTextFn).join('');
}

function extractTextWithTrailingNewline(
  element: Element,
  extractTextFn: (node: Node) => string,
): string {
  const text = extractTextFromChildNodes(element, extractTextFn).trim();

  return text ? `${text}\n` : '';
}

export function extractText(node: Node): string {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent || '';
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }

  const { tagName } = node as Element;

  if (tagName === 'LI' || tagName === 'P') {
    return extractTextWithTrailingNewline(node as Element, extractText);
  }

  if (tagName === 'BR') {
    return '\n';
  }

  return extractTextFromChildNodes(node, extractText);
}

export function extractTextFromHtml(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  return extractText(doc.body).trim();
}
